import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle, HeartCrack, BatteryWarning } from 'lucide-react';
export function ProblemSection() {
  const monsters = [{
    icon: BatteryWarning,
    title: 'Agotamiento',
    desc: 'Porque no hay turnos ni límites. Tu energía se drena sin pausa.'
  }, {
    icon: HeartCrack,
    title: 'Culpa',
    desc: 'Porque sientes que descansar es egoísmo. Te castigas por necesitar aire.'
  }, {
    icon: AlertCircle,
    title: 'Resentimiento',
    desc: 'Porque otros siguen su vida mientras tú sostienes todo el peso.'
  }];
  return <section className="py-10 px-4 bg-navy text-cream overflow-hidden" data-id="element-349">
      <div className="max-w-4xl mx-auto space-y-6" data-id="element-350">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center space-y-4" data-id="element-351">
          <h2 className="text-3xl md:text-4xl font-serif font-bold" data-id="element-352">
            El problema real no es tu falta de amor. <br data-id="element-353" />
            <span className="text-terracotta" data-id="element-354">Es la falta de estructura.</span>
          </h2>
          <p className="text-lg text-cream/80 max-w-2xl mx-auto" data-id="element-355">
            El cuidado sin estructura crea tres monstruos que se alimentan de tu
            paz mental:
          </p>
        </motion.div>

        {/* The 3 Monsters */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-356">
          {monsters.map((item, index) => <motion.div key={item.title} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="bg-white/5 backdrop-blur-sm p-6 rounded-xl border border-white/10 hover:border-terracotta/50 transition-colors" data-id="element-357">
              <item.icon className="w-10 h-10 text-terracotta mb-4" data-id="element-358" />
              <h3 className="text-xl font-serif font-bold mb-2" data-id="element-359">
                {item.title}
              </h3>
              <p className="text-cream/70 text-sm leading-relaxed" data-id="element-360">
                {item.desc}
              </p>
            </motion.div>)}
        </div>

        {/* The Cycle */}
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="relative py-4" data-id="element-361">
          <div className="absolute inset-0 flex items-center justify-center opacity-10" data-id="element-362">
            <div className="w-64 h-64 border-4 border-dashed border-cream rounded-full animate-spin-slow" data-id="element-363"></div>
          </div>

          <div className="relative text-center space-y-4" data-id="element-364">
            <p className="text-xl font-light" data-id="element-365">
              Y si has intentado "aguantar tantito más", probablemente ya viste
              el patrón:
            </p>

            <div className="flex flex-wrap justify-center items-center gap-4 text-sm md:text-base font-medium text-terracotta" data-id="element-366">
              <span data-id="element-367">Aguantas</span>
              <span className="text-cream" data-id="element-368">→</span>
              <span data-id="element-369">Te saturas</span>
              <span className="text-cream" data-id="element-370">→</span>
              <span className="font-bold text-white bg-terracotta px-2 py-1 rounded" data-id="element-371">
                Explotas o te apagas
              </span>
              <span className="text-cream" data-id="element-372">→</span>
              <span data-id="element-373">Te culpas</span>
              <span className="text-cream" data-id="element-374">→</span>
              <span data-id="element-375">Vuelves a aguantar</span>
            </div>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="text-center border-t border-white/10 pt-6" data-id="element-376">
          <p className="text-2xl md:text-3xl font-serif italic text-cream/90" data-id="element-377">
            "No es que no seas fuerte. <br data-id="element-378" />
            Es que este sistema está diseñado para quebrarte."
          </p>
        </motion.div>
      </div>
    </section>;
}